module.exports = __webpack_public_path__ + "img/165.08baf694.jpg";